import * as React from 'react';

import { NativeDataContext } from 'bundles/promo-template/components/NativeDataContext';
import type { NativeDataKey } from 'bundles/promo-template/components/NativeDataContext';
import ProgramDataSource from 'bundles/promo-template/contentful/modules/data-source/ProgramDataSource';

type Props = {
  dataSources: Array<NativeDataKey>;
};

/**
 * Auxiliary component to set the expected data sources in the context.
 * NOTE that this component should not be merged into `DataSourceLoader`.
 * The reason is that `DataSourceLoader` is a component that renders the data sources.
 * So the dependencies graph is like (-> is the direction of updating):
 *     DataSourceLoader -> *DataSource -> NativeDataContext -> ExpectedDataSources
 *
 * If we merge this component into `DataSourceLoader`,
 * the dependencies graph will become:
 *     DataSourceLoader -> *DataSource -> NativeDataContext -> DataSourceLoader
 * and cause an infinite re-render loop.
 */
function ExpectedDataSources({ dataSources }: Props) {
  const { setExpectedDataKeysRef } = React.useContext(NativeDataContext);
  setExpectedDataKeysRef(dataSources);

  return null;
}

function DataSourceLoader({ dataSources }: Props) {
  return (
    <>
      <ExpectedDataSources dataSources={dataSources} />
      {dataSources.map((ds) => {
        let el;

        switch (ds) {
          case 'program':
            el = <ProgramDataSource key={ds} />;
            break;
          default:
            el = null;
        }

        return el;
      })}
    </>
  );
}

export default DataSourceLoader;
